import { createSelector } from 'reselect'
import { AuthState } from 'src/modules/auth/auth_slice'
import { LoggedInUser } from 'src/modules/shared/Types'

const selectRaw: (state: any) => AuthState = (state) => state.auth
const selectLoggedInUser: (auth: AuthState) => LoggedInUser | null = createSelector(
  [selectRaw],
  (auth: AuthState) => auth.loggedInUser
)
const selectSignedIn = createSelector([selectLoggedInUser], (user: any) => Boolean(user) && Boolean(user.id))
//const selectLoading = createSelector([selectRaw], (auth) => Boolean(auth.loading))

//The currentUser object holds two sub-objects: organization and user. Example: currentUser = {organization:{...}, user:{...}}
//All user related data belongs to the currentUser.user object
// const selectLoggedInUserUser = createSelector([selectCurrentUser], (currentUser: any) =>
//   currentUser ? currentUser.user : null
// )

const selectCurrentUserFullName = createSelector(
  [selectLoggedInUser],
  (loggedInUser: LoggedInUser | null) => {
    return loggedInUser?.user?.name || 'n/a'}
)

const authSelectors = {
  selectRaw,
  selectLoggedInUser,
  selectSignedIn,
  selectCurrentUserFullName
}

export default authSelectors
